import { Directive, ElementRef, HostListener, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import * as _ from 'lodash';
import { Subscription } from 'rxjs';
import { Broadcaster } from '../components/broadcaster.component';

@Directive({
  selector: '[stickyFooter]'
})
export class StickyFooterDirective implements OnInit {

  // document
  documentEl: any;
  documentElementTag: string = 'router-container';
  documentScroll: number = 0;
  navbarheight: number = 64;

  // header
  headerElementTag: string = 'thead';
  headerEl: any;

  // footer
  footerElementTag: string = 'tfoot';
  footerEl: any;
  footerElHeight: number = 0;
  footerElMaxYOffset: number = 0;
  footerElYOffset!: number;
  footerElOriginalStyle: any;
  footerElColumnWidths: number[] = [];
  footerElCellsElementTag: string = 'td';

  // first row
  bodyElementTag: string = 'tbody';
  firstRowEl: any;
  // firstRowElOriginalHeight: number;
  // firstRowColumnWidths: number[] = [];
  // firstRowCellsElementTag: string = 'mat-cell';

  // rows
  lastRowTotal: number = 0;
  maxRowTotal: number = 0;

  constructor(
    private el: ElementRef,
    private _broadcaster: Broadcaster,
  ) {
    this.registerStringBroadcast();
  }

  ngOnInit() {
    this.documentEl = window.document.getElementById(this.documentElementTag);
    this.registerDomChangedEvent();
  }

  registerDomChangedEvent() {
    const observer = new MutationObserver(list => {
      this.getDispositions();
      const evt = new CustomEvent('dom-changed', { detail: list, bubbles: true });
      this.el.nativeElement.dispatchEvent(evt);
    });
    const attributes = false;
    const childList = true;
    const subtree = true;
    observer.observe(this.el.nativeElement, { attributes, childList, subtree });
  }

  /*
  // @HostListener('scroll', ['$event'])
  @HostListener('window:scroll', ['$event'])
  onWindowScroll($event) {
    console.log('StickyFooterDirective: onWindowScroll');
    // this.getDispositions();
  }
  */

  scrollSubscription!: Subscription;
  registerStringBroadcast() {
    this.scrollSubscription = this._broadcaster.on<string>('OnScroll')
      .subscribe(() => {
        this.getDispositions();
      });
  }

  ngOnDestroy() {
    this.scrollSubscription.unsubscribe();
  }

  getDispositions() {
    this.documentScroll = this.documentEl.scrollTop;
    if (this.el.nativeElement) {
      let header = this.el.nativeElement.getElementsByTagName(this.headerElementTag);
      let headerRows = header[0].getElementsByTagName('tr');
      if (headerRows.length > 0) this.headerEl = headerRows[0];

      let footer = this.el.nativeElement.getElementsByTagName(this.footerElementTag);
      let footerRows = footer[0].getElementsByTagName('tr');
      if (footerRows.length > 0) this.footerEl = footerRows[0];
      if (this.footerEl) {
        this.footerElHeight = this.footerEl.getBoundingClientRect().height;
        this.footerElYOffset = this.footerEl.getBoundingClientRect().bottom + this.documentScroll;
        if (this.footerEl.style.position != 'fixed') {
          this.footerElMaxYOffset = this.footerElYOffset;
          this.footerElOriginalStyle = this.footerElOriginalStyle ? this.footerElOriginalStyle : _.cloneDeep(this.footerEl.style);
        }
        let tbody = this.el.nativeElement.getElementsByTagName(this.bodyElementTag)[0];
        this.firstRowEl = tbody.getElementsByTagName('tr')[0];
        this.lastRowTotal = tbody.getElementsByTagName('tr').length;
        if (this.lastRowTotal > this.maxRowTotal) this.maxRowTotal = this.lastRowTotal;

        if (!this.footerElColumnWidths.length) {
          let cells = this.footerEl.getElementsByTagName(this.footerElCellsElementTag);
          for (let i = 0; i < cells.length; i++) {
            this.footerElColumnWidths[i] = cells[i].getBoundingClientRect().width;
          }
        }
        this.evaluatePositions();
      }
    }
  }

  evaluatePositions() {
    let headerElHeightOffset = this.headerEl.style.position == 'fixed' ? this.headerEl.getBoundingClientRect().height + 15 : 0;
    if (this.maxRowTotal > this.lastRowTotal) {
      this.resetFooterStyle();
      this.maxRowTotal = 0;
    } else if ((this.footerElMaxYOffset - headerElHeightOffset) > (this.documentEl.getBoundingClientRect().height + this.documentEl.scrollTop)) {
      this.setFooterStyle();
      this.setFooterColumnWidths();
    } else {
      this.resetFooterStyle();
    }
  }

  setFooterStyle() {
    this.footerEl.style.backgroundColor = '#f8f8f8';
    this.footerEl.style.position = 'fixed';
    this.footerEl.style.zIndex = 100;
    this.footerEl.style.bottom = '0px';
    this.footerEl.style.boxShadow = "0px -3px 10px rgba(0, 0, 0, 0.3)";
    if (this.firstRowEl)
      this.footerEl.style.width = this.firstRowEl.getBoundingClientRect().width + 'px';
  }

  resetFooterStyle() {
    this.footerEl.style = _.cloneDeep(this.footerElOriginalStyle);
  }

  setFooterColumnWidths() {
    let cells = this.footerEl.getElementsByTagName(this.footerElCellsElementTag);
    this.footerElColumnWidths.forEach((el, i) => {
      try { cells[i].style.width = el + 'px'; } catch (e) { }
    });
  }
}